import { render, staticRenderFns } from "./CompaniesTab.vue?vue&type=template&id=f451d8a2&scoped=true&"
import script from "./CompaniesTab.vue?vue&type=script&lang=js&"
export * from "./CompaniesTab.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesTab.vue?vue&type=style&index=0&id=f451d8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f451d8a2",
  null
  
)

export default component.exports